import { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../../helpers/classBuilders';
import { Stack } from '../Stack';
import { Heading, Paragraph } from '../Typography';

// Carries no styles; kept as a stable selector hook for the page shell.
const BASE_CLASSNAME = 'c-MainLayout';

interface Props extends PropsWithChildren {
  title: string;
  subtitle?: string | ReactNode;
  rightContent?: ReactNode;
  className?: string | string[] | Record<string, boolean>;
}

export const MainLayout = ({
  children,
  title,
  subtitle,
  rightContent,
  className,
}: Props) => {
  return (
    <main className={cn(BASE_CLASSNAME, className)}>
      <Stack direction="column" gap={7}>
        <Stack direction="row" justify="between">
          <Stack tag="header" direction="column" gap={2}>
            <Heading>{title}</Heading>
            {subtitle && (
              <>
                {typeof subtitle === 'string' ? (
                  <Paragraph>{subtitle}</Paragraph>
                ) : (
                  subtitle
                )}
              </>
            )}
          </Stack>
          {rightContent}
        </Stack>

        <div>{children}</div>
      </Stack>
    </main>
  );
};
